import { Directive, input, WritableSignal } from '@angular/core';

@Directive({
  selector: '[iotPlatformResizable]',
  host: {
    class: 'cursor-col-resize',
    '(mousedown)': 'onMouseDown($event)'
  }
})
export class ResizableDirective {
  readonly widthSignal = input.required<WritableSignal<number>>({ alias: 'iotPlatformResizable' });
  readonly minWidth = input(200);
  readonly maxWidth = input(600);

  onMouseDown(event: MouseEvent): void {
    event.preventDefault();
    const startX = event.clientX;
    const startWidth = this.widthSignal()();

    const onMouseMove = (e: MouseEvent) => {
      this.widthSignal().set(Math.min(this.maxWidth(), Math.max(this.minWidth(), startWidth + (e.clientX - startX))));
    };

    const onMouseUp = () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };

    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  }
}
